import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Nav = styled.nav`
  background: #000000;
  padding: 1rem;
  display: flex;
  justify-content: space-between; /* Space between buttons and logo */
  align-items: center;
`;

const NavLinksContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #fff;
  font-size: 1rem;
  transition: color 0.2s;

  &:hover {
    color: #0077b5;
  }
`;

const Logo = styled.img`
  height: 50px;
  cursor: pointer;
`;

const Navbar = () => {
  return (
    <Nav>
      <Link to="/">
        <Logo src="/logo.png" alt="Logo" /> 
      </Link>
      <NavLinksContainer>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/projects">Projects</NavLink>
        <NavLink to="/blog">Blog</NavLink>
        <NavLink to="/contact">Contact</NavLink>
      </NavLinksContainer>
    </Nav>
  );
};

export default Navbar;